const ADD_BULIDING_URL = "add-building";
const CONTACT_URL = "contact";

const BUILDING_PASSPORT_URL = "details";
export const ROUTE_PATHS = {
  addBuilding: () => ({
    isActive: (pathname: string) => pathname.includes(ADD_BULIDING_URL),
    navigateUrl: `/${ADD_BULIDING_URL}`,
    pagePath: () => `${ADD_BULIDING_URL}/:projectId?`,
    path: ADD_BULIDING_URL,
  }),
  buildingPassport: () => ({
    pagePath: () => `/${BUILDING_PASSPORT_URL}/:projectId/`,
  }),
  buildingProfile: (projectId: string | undefined) => ({
    navigateUrl: projectId ? `/${BUILDING_PASSPORT_URL}/${projectId}/buildingProfile` : undefined,
    pagePath: () => `buildingProfile`,
  }),
  contact: () => ({
    isActive: (pathname: string) => pathname.includes(CONTACT_URL),
    navigateUrl: `/${CONTACT_URL}`,
    path: CONTACT_URL,
  }),
  editBuilding: (projectId: string) => ({
    navigateUrl: `/${ADD_BULIDING_URL}/${projectId}`,
    path: `${ADD_BULIDING_URL}/${projectId}`,
  }),
};
